<template>
  <div class="nav-clock">
    <span class="nav-clock__icon"><feather-icon icon="ClockIcon" size="15"/></span>
    <div class="nav-clock__text">
      <span class="nav-clock__time">{{ currentTime }}</span>
      <span class="nav-clock__date">{{ currentDate }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'clock',
  data() {
    return {
      currentDate: '',
      currentTime: '',
      timer: null,
    };
  },
  mounted() {
    this.updateDateTime();
    this.timer = setInterval(this.updateDateTime, 1000);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    updateDateTime() {
      const now = this.$moment();
      this.currentDate = now.format(this.$t('timeFormat.date.format'));
      this.currentTime = now.format(this.$t('timeFormat.time.format'));
    },
  },
};
</script>

<style scoped>
.nav-clock {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 4px 13px 4px 5px;
  border-radius: 13px;
  background: rgba(0, 123, 255, 0.06);
  border: 1px solid rgba(0, 123, 255, 0.10);
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  user-select: none;
}
.nav-clock:hover {
  background: rgba(0, 123, 255, 0.10);
  box-shadow: 0 4px 12px -4px rgba(0, 123, 255, 0.35);
}

.nav-clock__icon {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #007BFF 0%, #4ba6ff 100%);
  box-shadow: 0 3px 8px -2px rgba(0, 123, 255, 0.5);
  flex-shrink: 0;
}

.nav-clock__text {
  display: flex;
  flex-direction: column;
  line-height: 1.05;
}
.nav-clock__time {
  font-weight: 700;
  font-size: 0.92rem;
  letter-spacing: 0.02em;
  color: #2f2b50;
  font-variant-numeric: tabular-nums;
}
.nav-clock__date {
  font-size: 0.68rem;
  font-weight: 500;
  color: #9aa0b0;
  letter-spacing: 0.02em;
}

/* Dark mode */
.dark-layout .nav-clock {
  background: rgba(123, 175, 255, 0.10);
  border-color: rgba(255, 255, 255, 0.08);
}
.dark-layout .nav-clock:hover {
  background: rgba(123, 175, 255, 0.16);
}
.dark-layout .nav-clock__time { color: #e8eaf0; }
.dark-layout .nav-clock__date { color: #8b93ab; }
</style>
